import { render, staticRenderFns } from "./LesiurtabItemTheme3.vue?vue&type=template&id=3a58b374&scoped=true"
import script from "./LesiurtabItemTheme3.vue?vue&type=script&lang=js"
export * from "./LesiurtabItemTheme3.vue?vue&type=script&lang=js"
import style0 from "./LesiurtabItemTheme3.vue?vue&type=style&index=0&id=3a58b374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58b374",
  null
  
)

export default component.exports